<template>
  <div class="window">
    <div class="w_content">
      <img v-if="!closeHide"
        src="/static/yuandan/close.png"
        class="close"
        mode=""
        @click="close"
      />
      <!-- <div class="title_red">登录后立即开启抽奖！</div> -->
      <div class="login_tab flex_c">
        <div
          class="tab_li"
          :class="tab_active == 1 ? 'tab_active' : ''"
          @click="change_tab(1)"
        >
          手机号登录
        </div>
        <div
          class="tab_li"
          :class="tab_active == 2 ? 'tab_active' : ''"
          @click="change_tab(2)"
        >
          邮箱登录
        </div>
      </div>
      <div class="tab_div">
        <div v-if="tab_active == 1">
          <div class="error">{{ error_index[0] }}</div>
          <div class="td_ipt flex_sb">
            <div class="code_down flex_sb" @click="show_code">
              <span>+{{ countrycode }}</span>
              <img src="/static/yuandan/down.png" class="img" mode="" />
            </div>
            <input
              type="number"
              placeholder="请输入手机号码"
              value=""
              id="number"
              v-model="number"
            />
            <div class="code_list" v-show="show_codelist">
              <div
                class="code_li flex_sb"
                v-for="(item, index) in code_list"
                :key="index"
                @click="select_code"
                :data-code="item.countryCode"
              >
                <img
                  :src="item.countryFlagImgUrl"
                  class="country_img"
                  mode=""
                />
                <div class="cou_name">{{ item.countryName }}</div>
                <div class="num">+{{ item.countryCode }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="error">{{ error_index[1] }}</div>
          <input
            type="text"
            value=""
            placeholder="请输入邮箱"
            class="td_ipt"
            v-model="email"
          />
        </div>
        <div class="error">{{ error_index[2] }}</div>
        <div class="td_ipt flex_sb">
          <input
            type="password"
            id="pass"
            value=""
            placeholder="请输入密码"
            v-model="password"
            :password="hide_pass"
          />
          <img
            src="/static/yuandan/eye_hide.png"
            class="eye"
            mode=""
            v-if="hide_pass"
            @click="show_pass(0)"
          />
          <img
            src="/static/yuandan/eye_show.png"
            class="eye"
            mode=""
            v-else
            @click="show_pass(1)"
          />
        </div>
      </div>
      <div class="no_account">
        没有账户，<span @click="go_register">马上注册一个</span>
      </div>
      <div class="login" @click="login">立即登录</div>
      <div class="warn" v-if="hide_warn!='yes'">
        <div class="p1">温馨提示：</div>
        <div class="p2">
          凡在考拉知道完成试听的用户，均享受免费抽奖资格，100%中奖！请注意：
        </div>
        <div class="p2">1、如您已完成试听，登录后即可抽奖。</div>
        <div class="p3">2、如您还没注册，马上注册吧！</div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../../../service/http";
import { Dialog, Loading } from "vant";
export default {
  data() {
    return {
      tab_active: 1, //tabactive序号
      hide_pass: true, //隐藏密码
      error_index: ["", "", ""], //错误信息的序号
      show_codelist: false, //是否展示区号列表
      countrycode: 1, //选择的国家区号
      number: "",
      email: "",
      password: "",
    };
  },
  components: {
    [Dialog.name]: Dialog,
  },
  props: ["code_list",'hide_warn','openid','closeHide'],
  mounted() {
    // console.log(this.code_list)
  },
  watch: {
    number() {
      this.$set(this.error_index, 0, "");
    },
    email() {
      this.$set(this.error_index, 1, "");
    },
    password() {
      this.$set(this.error_index, 2, "");
    },
  },
  methods: {
    //切换tab
    change_tab(e) {
      this.tab_active = e;
    },

    //展示国家区号
    show_code() {
      this.show_codelist = true;
    },
    //选择国家区号
    select_code(e) {
      this.countrycode = e.currentTarget.dataset.code;
      this.show_codelist = false;
    },
    //点击立即登录
    login() {
      var count = this.tab_active == 1 ? this.number : this.email;
      if (count == "" || count == null || count == undefined) {
        var msg = this.tab_active == 1 ? "*请输入手机号" : "*请输入邮箱";
        this.$set(this.error_index, this.tab_active - 1, msg);
      } else if (
        this.password == "" ||
        this.password == undefined ||
        this.password == null
      ) {
        this.$set(this.error_index, 2, "请输入密码");
      } else {
        this.func_login();
      }
    },
    //执行登录
    func_login() {
      var loginName =
          this.tab_active == 1 ? this.countrycode + this.number : this.email,
        that = this;
      var data = {
        cmd: "UserLogin",
        loginName: loginName,
        loginPwd: that.password,
      };
      if(that.openid){
          data.openId=that.openid
      }
      http.req(data, function (res) {
        if (res.flag != 1) {
          Dialog.alert({
            title: res.msg,
            showConfirmButton: false,
            closeOnClickOverlay: true,
            className: "Dialog",
            overlayStyle: { background: "transparent" },
		  });
		   setTimeout(() => {
            $(".Dialog,.van-overlay").remove();
          }, 2000);
        } else {
          localStorage.setItem("userinfo", JSON.stringify(res.info));
          localStorage.setItem(
            "isshiting",
            res.isShiTing == 0 ? "noshiting" : ""
          );
          localStorage.setItem(
            "iszhifu",
            res.isZhiFu == 0 ? "nozhifu" : "havezhifu"
          );
          that.$emit("havelogin");
        }
      },'');
    },
    //显示隐藏密码
    show_pass(e) {
      console.log(e);
      this.hide_pass = e == 1 ? true : false;
      if(e==1){
      $('#pass').attr('type','password')
      }else{

      $('#pass').attr('type','text')
      }
    },
    //马上注册
    go_register() {
      this.$emit("register", "true");
    },
    //关闭弹窗
    close() {
      this.$emit("close");
    },
    //
  },
};
</script>

<style scoped>
.w_content {
  width: 670px;
  background: #ffffff;
  box-shadow: 0px 8px 9px 1px rgba(195, 196, 196, 0.3);
  border-radius: 10px;
  padding: 34px 40px 97px;
  box-sizing: border-box;
}
.w_content .close {
  width: 29px;
  height: 31px;
  position: absolute;
  top: 22px;
  right: 24px;
}
.login_tab {
  font-size: 36px;
  font-weight: bold;
}
.login_tab .tab_li {
  width: 260px;
  border-bottom: 4px solid #ececec;
  line-height: 110px;
  text-align: center;
}
.login_tab .tab_active {
  color: #cf0c15;
  border-bottom: 7px solid #cf0c15;
}
.tab_div {
  margin: 3px 0 0 0;
}
.tab_div .error {
  color: #cf0c15;
  font-size: 24px;
  width: 100%;
  height: 60px;
  line-height: 60px;
  margin: 18px 0 0 0;
}
.tab_div .td_ipt {
  height: 88px;
  border: 2px solid #acacaa;
  border-radius: 44px;
  line-height: 88px;
  font-size: 28px;
  padding: 0 30px;
  box-sizing: border-box;
  position: relative;
  width: 100%;
}
.tab_div .td_ipt .img {
  width: 19px;
  height: 11px;
  margin: 0;
}
.tab_div .td_ipt .eye {
  width: 35px;
  height: 19px;
}
.tab_div .td_ipt .code_down {
  width: 101px;
  height: 80px;
  flex-shrink: 0;
  -webkit-flex-shrink: 0;
}
.tab_div .td_ipt input {
  flex: 1;
  -webkit-flex: 1;
  font-size: 28px;
  height: 80px;
}
#number {
  text-indent: 20px;
}
.no_account {
  text-align: right;
  font-size: 28px;
  line-height: 69px;
}
.no_account span {
  color: #cf0c15;
}
.login {
  height: 88px;
  background: #cf0c15;
  border-radius: 44px;
  font-size: 36px;
  line-height: 88px;
  text-align: center;
  color: #fff;
  margin: 62px auto 0;
}
.code_list {
  position: absolute;
  left: 0;
  background: #fff;
  border: 1px solid #e1e1e1;
  width: 591px;
  height: 695px;
  overflow-y: scroll;
  border-radius: 15px;
  top: 88px;
  z-index: 2;
}
.code_list .code_li {
  height: 86px;
  line-height: 86px;
  font-size: 32px;
  border-bottom: 1px solid #e1e1e1;
  padding: 0 20px;
  box-sizing: border-box;
}
.code_list .code_li .country_img {
  width: 48px;
  height: 36px;
  margin: 0 22px 0 0;
}
.code_list .code_li .cou_name {
  flex: 1;
  -webkit-flex: 1;
}
.code_list .code_li:active {
  background: #e1e1e1;
}

.warn {
  margin: 20px 0 0;
  padding: 0 20px;
  box-sizing: border-box;
}
.warn .p1 {
  font-size: 32px;
  color: #333;
  font-weight: bold;
  line-height: 60px;
}
.warn .p2,
.warn .p3 {
  font-size: 28px;
  color: #444;
  line-height: 34px;
  margin: 4px 0 0;
}
.warn .p2 {
  line-height: 40px;
}
.w_content {
  padding: 14px 20px 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/login/login.vue